import { render, staticRenderFns } from "./NewEquipmentType.vue?vue&type=template&id=771e7c10&scoped=true&"
import script from "./NewEquipmentType.vue?vue&type=script&lang=js&"
export * from "./NewEquipmentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771e7c10",
  null
  
)

export default component.exports